"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageElementRenderer = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  & > * {\n    flex: 1;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  & > * {\n    flex: 1;\n  }\n"])));
exports.ImageElementRenderer = (0, react_1.memo)(function (_a) {
    var imageElement = _a.imageElement;
    var elementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (elementRef.current == null)
            return;
        elementRef.current.innerHTML = ''; // reset
        elementRef.current.appendChild(imageElement);
    }, [imageElement]);
    return react_1.default.createElement(Root, { ref: elementRef });
});
exports.ImageElementRenderer.displayName = 'ImgWithLoading';
var templateObject_1;
